export function CardBody({ children }) {
  return <footer className="card-body">{children}</footer>;
}
